import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import numeral from "numeral";
import { ro } from "date-fns/locale";

const styles = StyleSheet.create({
  body: {
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 30,
    paddingRight: 20
  },
  title: {
    marginBottom: 3,
    fontSize: 18,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  text: {
    margin: 1,
    fontSize: 10,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  //TABLE-----------------------
   table: {
    width: '100%',
    top: 15,
    paddingBottom: 40
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  borderBottom: {
    borderBottom: '1 solid #0000'
  },
  bold: {
    fontWeight: 'bold',
  },
  rowText: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    fontWeight: 'bold',
  },
  alignLeft: {
    textAlign: 'left'
  },
  alignCenter: {
    textAlaign: 'center'
  },
  alignRight: {
    textAlign: 'right'
  },
  paddingNotes: {
    paddingBottom: 40
  },
  // So Declarative and unDRY 👌
  row1: {//suppid
    width: '13%',
  },
  row2: {//trandate
    width: '6%',
  },
  row3: {//pono
    width: '4%',
  },
  row4: {//total amt
    width: '8%',
  },
  row5: {//rcv all
    width: '7%',
  },
  row6: {//ispaid
    width: '8%',
  },
  // row7: {
  //   width: '3%',
  // },
  row8: {
    width: '8%',
  },
  row9: {
    width: '8%',
  },
  // row10: {
  //   width: '3%',
  // },
  row11: {//branchidno
    width: '7%',
  },
  // row12: {//notes
  //   width: '4%',
  // },
  row13: {//freight
    width: '4%',
  },
  row14: {//postatus
    width: '6%',
  },
  row15: {//dateapproved
    width: '7%',
  },
  // row16: {//isconverted
  //   width: '7%',
  // },
  row17: {//converted by
    width: '8%',
  },
  row18: {//dateconverted
    width: '6%',
  },
});



const PDFPurchasePayable = ({ data, dateFrom, dateTo }) => {

  return (
    <Document>
      <Page orientation="landscape" size="LEGAL" style={styles.body}>
        {/* <Text style={styles.header} fixed>qweqwe</Text> */}
        <Text style={styles.title}>
          Purchase Payable Report
        </Text>
        <Text style={styles.text}>
          Date From: {dateFrom}
        </Text>
        <Text style={styles.text}>
          Date To: {dateTo}
        </Text>
        
        {/* TABLE */}
        <View style={styles.table}>
          <View style={[styles.row, styles.rowText, styles.borderBottom]}>
            <Text style={[styles.row1, styles.rowText, styles.alignLeft]}>Supplier</Text>
            <Text style={[styles.row2, styles.rowText, styles.alignLeft]}>Tran Date</Text>
            <Text style={[styles.row3, styles.rowText, styles.alignLeft]}>PO No.</Text>
            
            <Text style={[styles.row5, styles.rowText, styles.alignLeft]}>Rcv All</Text>
            <Text style={[styles.row6, styles.rowText, styles.alignLeft]}>Is Paid</Text>
            <Text style={[styles.row8, styles.rowText, styles.alignLeft]}>Username</Text>
            <Text style={[styles.row9, styles.rowText, styles.alignLeft]}>Approver</Text>
            {/* <Text style={[styles.row10, styles.rowText, styles.alignLeft]}>Status</Text> */}
            <Text style={[styles.row11, styles.rowText, styles.alignLeft]}>BranchID No.</Text>
            <Text style={[styles.row13, styles.rowText, styles.alignLeft]}>Frieght</Text>
            <Text style={[styles.row14, styles.rowText, styles.alignLeft]}>PO Status</Text>
            <Text style={[styles.row15, styles.rowText, styles.alignLeft]}>Date Approved</Text>
            {/* <Text style={[styles.row16, styles.rowText, styles.alignLeft]}>Is Converted</Text> */}
            <Text style={[styles.row17, styles.rowText, styles.alignLeft]}>Converted By</Text>
            <Text style={[styles.row18, styles.rowText, styles.alignLeft]}>Date Converted</Text>
            <Text style={[styles.row4, styles.rowText, styles.alignRight]}>Total Amount</Text>
          </View>
          {data ? data.map((row, i) => (
            <View key={i} style={styles.row} wrap={false}>
              {/* <Text style={[styles.row10, styles.rowText, styles.alignRight]}>{numeral(row.tamount).format('00,0.00')}</Text> */}
              <Text style={[styles.row1, styles.rowText, styles.alignCenter]}>{row.supplier_name}</Text>
              <Text style={[styles.row2, styles.rowText, styles.alignLeft]}>{row.trandate}</Text>
              <Text style={[styles.row3, styles.rowText, styles.alignLeft]}>{row.pono}</Text>
              
              <Text style={[styles.row5, styles.rowText, styles.alignLeft]}>{row.rcvall}</Text>
              <Text style={[styles.row6, styles.rowText, styles.alignLeft]}>{row.ispaid}</Text>
              <Text style={[styles.row8, styles.rowText, styles.alignLeft]}>{row.username}</Text>
              <Text style={[styles.row9, styles.rowText, styles.alignLeft]}>{row.approver}</Text>
              {/* <Text style={[styles.row10, styles.rowText, styles.alignLeft]}>{row.status}</Text> */}
              <Text style={[styles.row11, styles.rowText, styles.alignLeft]}>{row.branchidno}</Text>
              <Text style={[styles.row13, styles.rowText, styles.alignLeft]}>{row.freight}</Text>
              <Text style={[styles.row14, styles.rowText, styles.alignLeft]}>{row.postatus}</Text>
              <Text style={[styles.row15, styles.rowText, styles.alignLeft]}>{row.dateapproved}</Text>
              {/* <Text style={[styles.row16, styles.rowText, styles.alignLeft]}>{row.isconverted}</Text> */}
              <Text style={[styles.row17, styles.rowText, styles.alignLeft]}>{row.convertedby}</Text>
              <Text style={[styles.row18, styles.rowText, styles.alignLeft]}>{row.dateconverted}</Text>
              <Text style={[styles.row4, styles.rowText, styles.alignRight]}>{numeral(row.totalamt).format('00,0.00')}</Text>
            </View>
          )) : ''}
      </View>

      {/* TOTALITIES */}
      {/* <Text style={[styles.text,styles.alignRight]}>
          Total: {grandTotal}
      </Text> */}

      {/* NOTES */}
      {/* <Text style={[styles.text,styles.alignLeft]}>
          **Notes**:
      </Text>
      <Text style={[styles.text,styles.alignLeft,styles.paddingNotes]}>
        {notes}
      </Text> */}

      {/* Encoded */}
      {/* <Text style={[styles.text,styles.alignLeft]}>
          |Encoded By: {encoder}
      </Text>
      <Text style={[styles.text,styles.alignLeft]}>
          |Approved By: {approver}
      </Text> */}


        <Text 
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />
      </Page>
    </Document>
  );
};

export default PDFPurchasePayable;